import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface IBreadcrumbPath {
  pathItems: IBreadcrumbPathItem[];
  tooltip?: string;
}

export interface IBreadcrumbPathItem {
  id: string;
  label: string;
  data?: any;
  disabled?: boolean; // whether the item can be selected
}

@Component({
    selector: 'app-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.scss'],
    standalone: false
})
export class BreadcrumbsComponent {
  @Input()
  set path(path: IBreadcrumbPath) {
    if (!path) {
      throw new Error('Cannot set breadcrumbs path to undefined.');
    }

    this._path = path;
    this.breadcrumbTip = this._path.tooltip ?? '';
    this.selectTailItem();
  }

  @Output()
  pathItemSelectedEvent = new EventEmitter<IBreadcrumbPathItem>();

  _path: IBreadcrumbPath = { pathItems: [] };
  selectedPathItem: IBreadcrumbPathItem | undefined = undefined;
  breadcrumbTip = '';
  delimiterSymbol = '>';

  onPathItemClick(pathItemIndex: number): void {
    this.setSelectedPathItem(this._path.pathItems[pathItemIndex]);
  }

  private selectTailItem(): void {
    if (this._path.pathItems.length > 0) {
      this.setSelectedPathItem(this._path.pathItems.slice(-1)[0]);
    }
  }

  private setSelectedPathItem(item: IBreadcrumbPathItem): void {
    if (this.selectedPathItem !== item) {
      this.selectedPathItem = item;
      this.firePathItemSelectedEvent();
    }
  }

  private firePathItemSelectedEvent(): void {
    this.pathItemSelectedEvent.emit(this.selectedPathItem);
  }
}
